import { API_URL, APP_API_PREFIX_GRID_UI, APP_API_PREFIX_ORGANIZATION } from 'config';

export const getGridlyApiPrefix = API_URL + APP_API_PREFIX_GRID_UI;
export const getOrganizationApiPrefix = API_URL + APP_API_PREFIX_ORGANIZATION;
